import { Component, h } from 'preact';
import getStore from '../../store';

import * as ResultsActions from '../../reducers/results/results.actions';
import { fbind } from 'q';
import { hiHideCustomerChat, hiShowCustomerChat } from '../../../helpers/customer-chat-loader';

interface ResultsMapMobileToggleState {
  isMapVisible?: boolean;
  buttonMessage: string;
}

'hi-results-map-mobile-toggle';
export class ResultsMapMobileToggle extends Component<any, ResultsMapMobileToggleState> {
  mapBlockNode: HTMLElement;
  resultsBlockNode: HTMLElement;
  seoBlockNode: HTMLElement;
  footerNode: HTMLElement;
  
  constructor(props) {
    super(props);

    this.setState({
      isMapVisible: false,
      buttonMessage: 'Map view'
    });

    this.mapBlockNode = document.getElementById('hiResultsPageMapMobile');
    this.resultsBlockNode = document.getElementById('hiResultsPageContainer');

    this.seoBlockNode = document.getElementById('hiResultsPageSeo');
    this.footerNode = document.getElementById('hiResultsPageFooter');
  }

  toggleFullScreen() {
    
  }

  onClick = (e) => {
    const store = getStore();

    store.dispatch({
      type: ResultsActions.TOGGLE_MAP
    });

    if (!this.state.isMapVisible) {
      hiHideCustomerChat();
    } else {
      hiShowCustomerChat();
    }

    this.setState({
      isMapVisible: !this.state.isMapVisible
    });

    // force scroll to go to top
    window.scroll(0,0);

    if (this.state.isMapVisible) {

      this.mapBlockNode.className = "hi-results-page__results__map-mobile visible";
      this.mapBlockNode.classList.add('mobile');
      this.resultsBlockNode.className = 'container d-none';

      if (this.seoBlockNode) {
        this.seoBlockNode.classList.add('d-none');
      }

      if (this.footerNode) {
        this.footerNode.classList.add('d-none');
      }

      this.setState({
        buttonMessage: 'List view'
      });
    } else {

      this.mapBlockNode.className = "hi-results-page__results__map-mobile";
      this.resultsBlockNode.className = 'container';
      this.mapBlockNode.classList.remove('mobile');

      if (this.seoBlockNode) {
        this.seoBlockNode.classList.remove('d-none');
      }

      if (this.footerNode) {
        this.footerNode.classList.remove('d-none');
      }

      this.setState({
        buttonMessage: 'Map view'
      });
    }
    
  }

  scrollToTop() {
    window.scrollBy(0,0);
  }

  render(props, state: ResultsMapMobileToggleState) {
    return (
      <div class="hi-results-map-mobile-toggle" id="hiResultsMapMobileToggle">
        <button class="btn btn-outline-dark hi-results-map-mobile-toggle__button"
          onClick={this.onClick}>
           { state.buttonMessage }
        </button>
      </div>
    );
  }
}